import { changeOrderTypeEndpoint } from "../../api/backend";
import { renderErrorMessage } from "../../utils";
import { showMessageModal, showOrderStatus } from "../../redux/actions";
import store from "../../redux/store";
import {
  MODIFY_ORDER_TYPE_PROMOTION,
  TEXT_CANCEL_ORDER,
  ORDER_PHASE_CONTACTING,
  PICKUP_STATUS,
  ORDER_PHASE_PREPARING,
  ORDER_PHASE_DELIVERING,
  ORDER_TYPE_DELIVERY,
  ORDER_PHASE_TAKEAWAY,
  ORDER_PHASE_WAITER,
  ERROR
} from "../../constants";
import { logHighError } from "../../utils/logger";
import { openMessageModal } from "../../utils/common";

export const changeOrderType = async (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  order: any,
  newOrderType: string,
  setLoadingChanginOrderType?: React.Dispatch<React.SetStateAction<boolean>>,
  refundReduction?: number
) => {
  const handleError = (error: any) => {
    openMessageModal(renderErrorMessage(error));
    logHighError(`Error changing order type ${error}`);
  };

  const handleLoading = (loading: boolean) => {
    setIsLoading(loading);
    if (setLoadingChanginOrderType) setLoadingChanginOrderType(loading);
  };

  try {
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.REFUND) {
      const discountMessage =
        refundReduction && refundReduction > 0
          ? `Annulez sans frais et recevez aussitôt un code promo de ${refundReduction}% pour votre prochaine commande.`
          : `Vous ne pouvez pas vous déplacer ? Annulez votre commande en cliquant sur le bouton ci-dessous.`;

      store.dispatch(
        showMessageModal(TEXT_CANCEL_ORDER, {
          discountMessage,
          showCancel: true,
          primaryColor: ERROR,
          onClick: async () => {
            setIsLoading(true);
            await changeOrderTypeEndpoint(order, newOrderType);
            store.dispatch(showOrderStatus(false));
            store.dispatch(
              showMessageModal(
                `Votre commande n°${order.orderNumber} a été annulée avec succès.`
              )
            );
          },
        })
      );
      return;
    }
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT) {
      handleLoading(true);
      await changeOrderTypeEndpoint(order, newOrderType);
    }
  } catch (error) {
    handleError(error);
  } finally {
    handleLoading(false);
  }
};

export const getActiveStep = (
  status: string,
  orderFlowReverse: boolean,
  orderType: string,
  pickupStatus: number
): number => {
  switch (status) {
    case ORDER_PHASE_CONTACTING:
      return orderFlowReverse &&
        pickupStatus === PICKUP_STATUS.DRIVER_ON_THE_WAY_TO_RESTAURANT
        ? 1
        : 0;
    case ORDER_PHASE_PREPARING:
      return orderFlowReverse && orderType === ORDER_TYPE_DELIVERY ? 2 : 1;
    case ORDER_PHASE_DELIVERING:
      return orderFlowReverse && orderType === ORDER_TYPE_DELIVERY ? 3 : 2;
    case ORDER_PHASE_TAKEAWAY:
    case ORDER_PHASE_WAITER:
      return 2;
    default:
      return 0;
  }
};
